import { useEffect } from "react";
import { navigationHold } from "@/lib/navigationHold";

/** Hold browser Back and page unload while `busy` (FP-038; see lib/navigationHold). */
export function useNavigationHold(busy: boolean) {
  useEffect(() => {
    if (!busy) return;
    const hold = navigationHold();
    hold?.acquire();
    return () => hold?.release();
  }, [busy]);
}
